import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "card-title mb-0"
}
const _hoisted_7 = { class: "m-0 card-text text-primary" }
const _hoisted_8 = {
  key: 2,
  class: "text-muted m-0",
  style: {"opacity":"0.7"}
}
const _hoisted_9 = {
  key: 3,
  class: "text-muted m-0",
  style: {"opacity":"0.7"}
}
const _hoisted_10 = {
  key: 4,
  class: "text-muted m-0",
  style: {"opacity":"0.7"}
}
const _hoisted_11 = { class: "card-footer text-body-secondary d-flex align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "m-0 text-warning",
  title: "Este evento acepta pagos con Bitcoin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.image,
            class: "card-img-top bg-dark",
            alt: _ctx.event.title
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logo,
              class: "w-auto h-100 logo mt-2"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (!_ctx.logo)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_ctx.event.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("small", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.date(_ctx.event?.date?.start).split("|")[0]), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.event?.date?.start).split("|")[1]), 1)
          ])
        ]),
        (_ctx.event.location.type == 'place')
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.event.location.address.name), 1),
              _createTextVNode(" • " + _toDisplayString(_ctx.event.location.address.city) + ", " + _toDisplayString(_ctx.event.location.address.state), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.event.location.type == 'to-be-announced')
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("strong", null, "Dirección por anunciar.", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.event.location.type == 'on-line')
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("strong", null, "El evento será en linea.", -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.event.accept_bitcoin)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_12, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fab fa-bitcoin" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.admin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = () => _ctx.goEdit(_ctx.event.id)),
              class: "btn btn-primary ms-auto"
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1),
              _createTextVNode(" Modificar ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.admin && !_ctx.event.archive)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: _cache[1] || (_cache[1] = () => _ctx.archiveEvent(_ctx.event.id)),
              class: "btn btn-secondary ms-2"
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.admin && _ctx.event.archive)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              onClick: _cache[2] || (_cache[2] = () => _ctx.unarchiveEvent(_ctx.event.id)),
              class: "btn btn-secondary ms-2"
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fas fa-undo" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
      ])
    ])
  ]))
}